import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Tabs } from "antd";
const HeaderTabs = ({ items, activeTabKey, setActiveTabKey }) => {
  return /* @__PURE__ */ jsx(
    Tabs,
    {
      activeKey: activeTabKey,
      items,
      onChange: setActiveTabKey,
      className: "primary-tab"
    }
  );
};
var stdin_default = memo(HeaderTabs);
export {
  stdin_default as default
};
